export enum Locale {
    PL = 'pl',
    EN = 'en',
    LT = 'lt',
    LV = 'lv',
    RU = 'ru',
    ES = 'es',
    UA = 'ua',
    CZ = 'cz',
    FR = 'fr',
    IT = 'it',
    DE = 'de',
    PT = 'pt',
    NL = 'nl',
    RO = 'ro',
}

export const OANDA_LANGUAGES = [
    'EN',
    'FR',
    'IT',
    'ES',
    'DE',
    'PT',
    'NL',
    'CZ',
    'LV',
    'LT',
    'RO',
];

export const TMS_LANGUAGES = ['PL', 'RU', 'UA'];
